import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthCallbackComponent } from 'auth-callback-lib';
import { authGuard } from './auth-guard.fn';
import { AuthRedirectComponent } from './components/login/auth-redirect.component';
import { SignInComponent } from './components/login/sign-in.component';
import { WorkflowConfigListViewComponent } from './components/workflow-config-list-view/workflow-config-list-view.component';

const routes: Routes = [
  {
    path: '',
    component: WorkflowConfigListViewComponent,
    canActivate: [authGuard],
  },
  { path: 'signin', component: SignInComponent },
  { path: 'callback', component: AuthCallbackComponent },
  { path: 'auth/:namespace/:tenant', component: AuthRedirectComponent, pathMatch: 'full' },
  { path: 'auth/:namespace', component: AuthRedirectComponent, pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
